// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__WH8Fi","type":"styles_type__1z9CK","choices":"styles_choices__2BSYg"};